/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TrackerMetadataEvent } from 'components/Tracker/TrackerProvider';
import { TrackerMetadataState } from 'types/trackerMetadata';
import initialTrackerMetadataState from './trackerMetadataState';

const trackerMetadata = createSlice({
  name: 'trackerMetadata',
  initialState: initialTrackerMetadataState,
  reducers: {
    setTrackerMetadata: (state: Partial<TrackerMetadataState>, action: PayloadAction<TrackerMetadataEvent>) => {
      state.userAgent = action.payload.userAgent;
      state.userEmail = action.payload.userEmail;
      state.userId = action.payload.userId;
      state.tenantId = action.payload.tenantId;
      state.orgId = action.payload.orgId;
      state.inspectionId = action.payload.inspectionId;
      state.path = action.payload.path;
      state.locale = action.payload.locale;
      state.userAgent = action.payload.userAgent;
    },
    setClientTimezoneOffset: (state: Partial<TrackerMetadataState>, action: PayloadAction<number | null>) => {
      state.clientTimezoneOffsetInMinutes = action.payload;
    },
  },
});

export const { setTrackerMetadata, setClientTimezoneOffset } = trackerMetadata.actions;

export const getTrackerMetadata = (state: {
  trackerMetadata: Partial<TrackerMetadataState>;
}): Partial<TrackerMetadataState> => state.trackerMetadata;

export const getClientTimezoneOffset = (state: {
  trackerMetadata: Partial<TrackerMetadataState>;
}): number | null | undefined => state.trackerMetadata.clientTimezoneOffsetInMinutes;

export default trackerMetadata;
/* eslint-enable no-param-reassign */
